import { CrlCategorizationFile, CrlItemCommentIds } from '../models';

/**
 * Opens the CRL-page subscriptions for a request (categorization + comments). A
 * new start tears down the previous ones first; a re-dispatch with the same id is
 * ignored so opening the item overlay (an aux route) doesn't churn them.
 */
export class StartCrlSubscriptions {
  static readonly type = '[CxpCrlSubscriptions] Start';
  constructor(public readonly requestId: number) {}
}

/** Tears down every open CRL-page subscription (page destroy / navigated away). */
export class StopCrlSubscriptions {
  static readonly type = '[CxpCrlSubscriptions] Stop';
}

/**
 * A categorization live-query emission for `requestId`. Replaces the stored file
 * snapshot and reconciles in-flight bulk upload toast rows to their terminal
 * display status. Stale emissions (for a request no longer subscribed) are dropped.
 */
export class ReceiveCategorizationFiles {
  static readonly type = '[CxpCrlSubscriptions] Receive Categorization Files';
  constructor(
    public readonly requestId: number,
    public readonly files: CrlCategorizationFile[],
  ) {}
}

/**
 * A comments live-query emission for `requestId`: the ids of the items that have
 * comments, and the subset with comments this caller has not viewed. Replaces the
 * stored snapshot. Stale emissions (for a request no longer subscribed) are dropped.
 */
export class ReceiveItemsWithComments {
  static readonly type = '[CxpCrlSubscriptions] Receive Items With Comments';
  constructor(
    public readonly requestId: number,
    public readonly comments: CrlItemCommentIds,
  ) {}
}

/**
 * Removes a bulk-uploaded file from the request (uncategorized-card "X").
 * Optimistically drops it from the snapshot; the subscription reconciles.
 * Keys on the FILE id.
 */
export class RemoveCategorizationFile {
  static readonly type = '[CxpCrlSubscriptions] Remove Categorization File';
  constructor(public readonly fileId: number) {}
}
